/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import {
    ConstrainedWrapper,
    ConstrainedWrapperGutter,
} from '@toucan/client/shared/components/constrained-wrapper';
import { SocialChannels } from '@toucan/client/shared/components/social-channels';

import { styles } from './pre-footer.styles';

export type PreFooterProps = {
    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
};

const StyledPreFooter = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const PreFooter: FunctionComponent<PreFooterProps> = ({
    ...otherProps
}: PreFooterProps) => (
    <StyledPreFooter {...otherProps}>
        <ConstrainedWrapper
            className="pre-footer"
            data-testid="pre-footer"
            gutter={ConstrainedWrapperGutter.LARGE_GUTTER}
        >
            <SocialChannels
                className="social-links"
                data-testid="pre-footer__social-links"
            />
        </ConstrainedWrapper>
    </StyledPreFooter>
);
